<template>
  <v-card>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
      <v-tabs v-model="tab" background-color="primary" dark icons-and-text grow>
        <v-tab href="#tab-admins">
          <span class="mt-2">Admins</span>
          <v-icon>verified_user</v-icon>
        </v-tab>
        <v-tab-item value="tab-admins" class="grey lighten-5">
          <RightsUserAutocomplete
            :organizationUsers="organizationUsers"
            v-on:addUser="addAdminUser"
          />
          <RightUsersTable
            :data="admins ? admins: []"
            :headers="headers"
            :isLoading="isLoading"
            v-on:removeOne="removeOneAdmin"
          />
        </v-tab-item>
        <v-tab href="#tab-editors">
          <span class="mt-2">Editors</span>
          <v-icon>assignment_ind</v-icon>
        </v-tab>
        <v-tab-item value="tab-editors" class="grey lighten-5">
          <RightsUserAutocomplete
            :organizationUsers="organizationUsers"
            v-on:addUser="addEditorUser"
          />
          <RightUsersTable
            :data="editors ? editors: []"
            :headers="headers"
            :isLoading="isLoading"
            v-on:removeOne="removeOneEditor"
          />
        </v-tab-item>
        <v-tab href="#tab-viewers">
          <span class="mt-2">Viewers</span>
          <v-icon>face</v-icon>
        </v-tab>
        <v-tab-item value="tab-viewers" class="grey lighten-5">
          <RightsUserAutocomplete
            :organizationUsers="organizationUsers"
            v-on:addUser="addViewerUser"
          />
          <RightUsersTable
            :data="viewers ? viewers: []"
            :headers="headers"
            :isLoading="isLoading"
            v-on:removeOne="removeOneViewer"
          />
        </v-tab-item>
      </v-tabs>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="cancel">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import RightsUserAutocomplete from "./RightsUserAutocomplete";
import RightUsersTable from "./RightUsersTable";

export default {
  components: {
    RightsUserAutocomplete,
    RightUsersTable
  },
  props: {
    title: { type: String, required: true },
    admins: { type: Array, required: true },
    editors: { type: Array, required: true },
    viewers: { type: Array, required: true },
    organizationUsers: { type: Array, required: true },
    isLoading: { type: Boolean, required: true }
  },
  data() {
    return {
      tab: null,
      headers: [
        {
          text: "First Name",
          align: "start",
          filterable: true,
          value: "first_name",
          width: "20%"
        },
        {
          text: "Last Name",
          align: "start",
          filterable: true,
          value: "last_name",
          width: "20%"
        },
        {
          text: "Email",
          align: "start",
          filterable: true,
          value: "email",
          width: "30%"
        },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ]
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    addAdminUser(user) {
      this.$emit("addAdminUser", user);
    },
    addEditorUser(user) {
      this.$emit("addEditorUser", user);
    },
    addViewerUser(user) {
      this.$emit("addViewerUser", user);
    },
    removeOneAdmin(user) {
      this.$emit("removeOneAdmin", user);
    },
    removeOneEditor(user) {
      this.$emit("removeOneEditor", user);
    },
    removeOneViewer(user) {
      this.$emit("removeOneViewer", user);
    }
  }
};
</script>

<style>
</style>